import { ColourSwatch } from './ColourSwatch';

export const SelectableColourSwatch = ({
    id,
    currentColour,
    colours,
    setColours,
    selectedColours,
    setSelectedColours,
}) => {
    const setCurrentColourAsSelected = () => {
        const selectedColour = { ...currentColour, selected: true };
        const updatedColours = colours.map(colour => {
            return colour === currentColour ? selectedColour : colour;
        });

        const updatedSelectedColours = [...selectedColours, selectedColour]
            .map((colour, index) => ({...colour, position: index}))

        setColours(updatedColours);
        setSelectedColours(updatedSelectedColours);
    };

    return (
        <ColourSwatch
            testId={`colour-swatch-${id}`}
            id={id}
            colour={currentColour}
            size="med"
            onClick={currentColour.selected ? () => {} : setCurrentColourAsSelected}
            invisible={currentColour.selected}
        />
    );
};
